'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { pageView } from '../lib/GTM/pageView';

export default function Analytics() {
    const pathname = usePathname();

    useEffect(() => {
        pageView(pathname);
    }, [pathname]);

    return null;
}
